import { Conversation } from 'ha/services/apiV2/types/Conversation';
import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';

interface Query {
  expand: string;
}

export default (makeCall: MakeCall) => (userId: number, query?: Query) =>
  makeCall<Conversation[]>('GET', `${APIV2_URL}/conversations/user/${userId}`, {
    query,
  });
